import { INearestBranch } from '../types/NearestBranch';

export const getNearestBranch = (item?: INearestBranch) => ({
  id: item?.id ?? 0,
  branch_id: item?.branch_id ?? 0,
  polygon: item?.polygon ?? '',
  update: item?.updated ?? '',
});
